"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/elements/status.css");

var _Icone = require("./Icone");

var _Icone2 = _interopRequireDefault(_Icone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// export default class Status extends React.Component {

//     getStyle = () =>{
//         let estilo = this.props.status ? 'text-success  hidden-read' : 'text-danger hidden-read';
//         estilo = estilo + (this.props.width ? " mdl-cell mdl-cell--"+this.props.width+"-col" : "")
//         return estilo
//     }

//     render() {
//         return (
//             <span className={"status "+this.getStyle()}>
//                 {this.props.status !== undefined ? <Icon name="circle"/> : undefined}

//                 {this.props.status !== undefined ?
//                     <span className="text">{this.props.status ? "Ativo" : "Inativo"}</span> : undefined}
//             </span>
//         );
//     }

// }

var Status = function (_React$Component) {
    _inherits(Status, _React$Component);

    function Status(props) {
        _classCallCheck(this, Status);

        var _this = _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).call(this, props));

        _this.getTooltip = function (tooltip, content) {
            return tooltip ? _react2.default.createElement(
                "div",
                { className: "tooltips", style: { top: _this.state.top, left: _this.state.left } },
                _react2.default.createElement(
                    "div",
                    { className: "mdl-tooltip mdl-tooltip--top", "aria-hidden": "true" },
                    content
                )
            ) : null;
        };

        _this.setActive = function () {
            var element = document.getElementById(_this.state.id);
            var rect = element.getBoundingClientRect();
            var top = rect.top + 25;
            var left = rect.left - 37;
            _this.setState({ top: top, left: left });
        };

        _this.state = {
            top: '',
            left: '',
            id: Math.random()
        };
        return _this;
    }

    _createClass(Status, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                status = _props.status,
                possibleStatus = _props.possibleStatus,
                content = _props.content,
                tooltip = _props.tooltip;


            if (status !== undefined) {
                return _react2.default.createElement(
                    "span",
                    { className: 'text-' + (status ? 'success' : 'danger') + ' hidden-read toolips-area', "aria-label": tooltip || "",
                        onMouseOver: this.setActive, id: this.state.id },
                    _react2.default.createElement(_Icone2.default, { icone: "circle", "aria-hidden": "true", fontAwesome: true }),
                    this.getTooltip(tooltip, status ? 'Ativo' : 'Inativo'),
                    _react2.default.createElement(
                        "span",
                        { className: "text" },
                        " ",
                        status ? "Ativo" : "Inativo",
                        " "
                    ),
                    content === undefined ? null : _react2.default.createElement(
                        "small",
                        { className: "status-content" },
                        " ",
                        content,
                        " "
                    )
                );
            } else if (possibleStatus) {
                var currentStatus = possibleStatus.find(function (s) {
                    return s.content === content;
                });

                return _react2.default.createElement(
                    "span",
                    { className: currentStatus.className + ' hidden-read toolips-area', "aria-label": tooltip || "",
                        onMouseOver: this.setActive, id: this.state.id },
                    _react2.default.createElement(_Icone2.default, { icone: "circle", "aria-hidden": "true", fontAwesome: true }),
                    this.getTooltip(tooltip, currentStatus.content),
                    _react2.default.createElement(
                        "span",
                        { className: "text" },
                        " ",
                        currentStatus.content,
                        " "
                    )
                );
            } else {
                return null;
            }
        }
    }]);

    return Status;
}(_react2.default.Component);

exports.default = Status;


Status.propTypes = {
    status: _propTypes2.default.bool,
    possibleStatus: _propTypes2.default.array,
    content: _propTypes2.default.string,
    tooltip: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/elements/Status.js
// module id = 344
// module chunks = 0